import React from 'react';
import { useIntl } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import Section from 'components/structure/Section';
import Block from 'components/structure/Block/Block';
import CollapsePanel from 'components/ui/CollapsePanel/CollapsePanel';
import { maybeFormatMessage } from 'utils/i18nUtils';

import { StyledList, StyledListItem } from './styles/List';

const questionKeys = [
  'WHAT_IS',
  'WHAT_IS_IT_FOR',
  'BENEFITS',
  'CONSULT',
  'PRIVACY',
  'DIFFER',
  'REPORT_ERROR',
];

function SectionFAQ() {
  const intl = useIntl();

  return (
    <Section
      id="faq"
      backgroundColor="white.dark"
    >
      <Block justifyContent="center" blockWidth="100%">
        <Typography
          variant="title"
          color="black"
          colorVariant="default"
          gutterBottom={4}
          intlKey="SCR.FAQ.TITLE"
        />
        <StyledList>
          {questionKeys.map(key => (
            <StyledListItem key={key}>
              <CollapsePanel
                title={maybeFormatMessage(intl, 'SCR.FAQ', `${key}.QUESTION`)}
                body={maybeFormatMessage(intl, 'SCR.FAQ', `${key}.ANSWER`)}
              />
            </StyledListItem>
          ))}
        </StyledList>
      </Block>
    </Section>
  );
}

export default React.memo(SectionFAQ);
